import Icon, { CloseOutlined } from '@ant-design/icons';
import { Button, Flex, Modal } from 'antd';
import React from 'react';
import CustomReduceIcon from '~/assets/svg/icon-reduce.svg?react';
import SpellCheckerInput from '~/components/shared/SpellCheckerInput/SpellCheckerInput';

function FullscreenEditorModal({
  open,
  onClose,
  title,
  editorRef,
  placeholder,
  defaultValue,
  onChange,
  onSubmit,
  submitText,
  submitIcon,
  loading,
  disabled,
  footerExtra,
  children,
}) {
  return (
    <Modal open={open} closeIcon={null} footer={null} onCancel={onClose} centered destroyOnClose width={900} classNames={{ content: '!p-0' }}>
      <Flex vertical className='h-[80vh]'>
        <Flex justify='space-between' align='center' className='py-s px-m shrink-0 border-0 border-b border-solid border-grey'>
          <p className='h2'>{title}</p>
          <Button type='text' className='btn-icon' size='large' onClick={onClose} icon={<CloseOutlined />} />
        </Flex>
        <div className='p-m grow overflow-y-auto flex flex-col gap-s fullscreen-message-content'>
          <SpellCheckerInput ref={editorRef} placeholder={placeholder} textArea defaultValue={defaultValue} onChange={onChange} />
          {children}
        </div>
        <Flex justify='flex-end' align='center' gap={8} className='px-m py-s shrink-0' style={{ boxShadow: '0 0 16px 0 #D5D5D8' }}>
          <Button type='text' className='btn-icon' size='large' onClick={onClose}>
            <Icon component={CustomReduceIcon} />
          </Button>
          {footerExtra}
          <Button
            type='primary'
            className='btn-success'
            onClick={() => {
              onClose();
              onSubmit();
            }}
            loading={loading}
            disabled={disabled}
          >
            {submitText}
            {!loading && submitIcon}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default FullscreenEditorModal;
